export type DirectMpBlockedReason = "mp-wall";

export const MP_WALL_DIRECT_MP_BLOCKED_REASON: DirectMpBlockedReason =
  "mp-wall";
